export const relationshipCompanyHeadCells = [
	{ id: 'name', numeric: false, label: 'Company name', align: 'left', hideable: false },
	{ id: 'tradingName', numeric: false, label: 'Trading name', align: 'left' },
	{ id: 'email', numeric: false, label: 'Company email', align: 'left' },
	{ id: 'phone', numeric: false, label: 'Company phone', align: 'left' },
	{ id: 'ownerDocId', numeric: false, label: 'Company owner', align: 'left' },
	{ id: 'brokerGroupId', numeric: false, label: 'Broker group', align: 'left' },
	{ id: 'contactName', numeric: false, label: 'Primary contact', align: 'left' },
	{ id: 'contactEmail', numeric: false, label: 'Primary contact email', align: 'left' },
	{ id: 'contactPhone', numeric: false, label: 'Primary contact phone', align: 'left' },
	{ id: 'createdAt', numeric: false, date: true, label: 'Created', align: 'left' },
	{ id: 'createdBy', numeric: false, label: 'Created by', align: 'left' },
	{ id: 'lastUpdated', numeric: false, date: true, label: 'Last updated', align: 'left' },
	{ id: 'lastUpdatedBy', numeric: false, label: 'Last modified by', align: 'left' },
];

export const DEFAULT_HIDDEN_COLUMNS = [
	'ownerDocId',
	'brokerGroupId',
	'contactName',
	'contactEmail',
	'contactPhone',
	'createdAt',
	'createdBy',
	'lastUpdated',
	'lastUpdatedBy',
];
